import axios from './axiosInstance';
import { APIOfficialRequest, APIRoleDefinition } from '../../types';

interface SportAreaParams {
  sport: string;
  areaId: string;
}

interface ChangeUserRoleParams extends SportAreaParams {
  userId: string;
  newRole: string;
}

interface RemoveUserRoleParams extends SportAreaParams {
  userId: string;
  role: string;
}

interface RespondToOfficialRequestParams extends SportAreaParams {
  requestId: string;
  isRequestApproved: boolean;
}

const getOfficialRequests = ({ sport, areaId }: SportAreaParams): Promise<APIOfficialRequest[] | void> => {
  return axios.get(`/${sport}/areas/${areaId}/officialrequests`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getRoleDefinitions = ({ sport, areaId }: SportAreaParams): Promise<APIRoleDefinition[]> => {
  return axios.get(`/${sport}/areas/${areaId}/roles/definitions`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
}

const changeUserRole = ({ sport, areaId, userId, newRole }: ChangeUserRoleParams): Promise<any> => {
  return axios.post(`/${sport}/areas/${areaId}/officialrequests/changeuserrole`, {
    userId,
    newRole,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const removeUserRole = ({ sport, areaId, userId, role }: RemoveUserRoleParams): Promise<any> => {
  return axios.post(`/${sport}/areas/${areaId}/officialrequests/removeuserrole`, {
    userId,
    role,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error
    });
};

const respondToOfficialRequest = ({ sport, areaId, requestId, isRequestApproved }: RespondToOfficialRequestParams): Promise<any> => {
  return axios.post(`/${sport}/areas/${areaId}/officialrequests/${requestId}`, {
    id: requestId,
    approved: isRequestApproved,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const resortFunctions = {
  getOfficialRequests,
  getRoleDefinitions,
  changeUserRole,
  removeUserRole,
  respondToOfficialRequest,
};

export default resortFunctions;
